import { schema } from 'normalizr';

import { getFeedItemTypedId } from '../utils';

const topic = new schema.Entity('topics');
const post = new schema.Entity(
  'posts',
  {},
  { idAttribute: getFeedItemTypedId },
);
const partner = new schema.Entity('partners');
const expert = new schema.Entity('experts');
const link = new schema.Entity('links');
const socialLink = new schema.Entity('social_links');
const following = new schema.Entity('followings');
const linkedEvent = new schema.Entity('linked_events');
const category = new schema.Entity('categories');
const member = new schema.Entity('members');

topic.define({
  posts: [post],
  partners: [partner],
  experts: [expert],
  links: [link],
  social_links: [socialLink],
  followings: [following],
  linked_events: [linkedEvent],
  topic: category,
});

export default {
  TOPICS: {
    topics: [topic],
    categories: [category],
  },
  TOPIC: topic,
  MEMBERS: [member],
  POSTS: [post],
  POST: post,
  PARTNER: partner,
  EXPERT: expert,
  FOLLOWINGS: [following],
  FOLLOWING: following,
  LINKED_EVENT: linkedEvent,
};
